/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React, { forwardRef } from 'react'
// @ts-ignore
import { Line } from '@netbasequid/chart'
import { useDisplayTheme } from 'hooks/useUiState'
import { LineProps } from './types'

const tooltipDateFormats = {
  hour: '%A, %b %e, %H:%M',
  day: '%A, %b %e, %Y',
  week: '%A, %b %e, %Y',
  month: '%A, %b %e, %Y',
  year: '%A, %b %e, %Y'
}

const LineChart = forwardRef(
  (
    {
      series,
      timeUnit,
      yAxisTitle,
      seriesHeader,
      colorSettings,
      onClickChart,
      onClickPoint,
      onSelection,
      isTooltipEnabled,
      rawAnnotations,
      simplifiedAnnotations
    }: LineProps,
    ref
  ) => {
    const theme = useDisplayTheme()

    return (
      <Line
        ref={ref}
        mode={theme}
        data={series}
        xAxisUnit="datetime"
        yAxisTitle={yAxisTitle}
        type="spline"
        showMarker
        legendPosition="bottom"
        timeUnit={timeUnit}
        tooltipDateFormats={tooltipDateFormats}
        seriesHeader={seriesHeader}
        colorSettings={colorSettings}
        onClickChart={onClickChart}
        onClickPoint={onClickPoint}
        onSelection={onSelection}
        isTooltipEnabled={isTooltipEnabled}
        rawAnnotations={rawAnnotations}
        simplifiedAnnotations={simplifiedAnnotations}
      />
    )
  }
)

export default LineChart
